angular.module('rjmNg.directives').directive "popoverClickOut", [
  "$window"
  "$rootScope"
  ($window, $rootScope) ->
    restrict: "A"
    (scope, element, attrs) ->

      $rootScope.$on "popover-shown", (event,args) ->
        $("html").on "click.#{args.target.id}", (e) ->
          # Close the popover if we click anywhere but inside a popover or if the parent is not in the DOM. Sometimes this happens on dropdown menus inside popovers.
          if not $(e.target).parents().hasClass("popover") and $(e.target).parents('html').length > 0
            event.targetScope.hide()
            $("html").off "click.#{args.target.id}"
  ]
